/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const t={date:[],dateOnly:[],id:["is","isNot","startsWith","endsWith","contains","doesNotContain"],number:["is","isNot","startsWith","endsWith","contains","doesNotContain","isBlank","isNotBlank"],timeOnly:[],timestampOffset:[],string:["is","isNot","startsWith","endsWith","contains","doesNotContain","isBlank","isNotBlank","isEmpty","isNotEmpty"]};export{t as defaultOperatorNamesByFieldType};
